import React, { useEffect } from 'react';
import contactRef from '../../components/Footer/Footer';
import config from '../../config';
import { twitterPageURL } from '../../util/urlHelpers';
import {
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
  ExternalLink,
} from '../../components';
import StaticPage from '../../containers/StaticPage/StaticPage';
import TopbarContainer from '../../containers/TopbarContainer/TopbarContainer';

import css from './FAQPage.module.css';
import * as PropTypes from 'prop-types';

const FAQPage = () => {
  const { siteTwitterHandle, siteFacebookPage } = config;
  const siteTwitterPage = twitterPageURL(siteTwitterHandle);
  // prettier-ignore
  return (
    <StaticPage
      title="FAQ Page"
      schema={{
        '@context': 'http://schema.org',
        '@type': 'FAQPage',
        description: 'WeCycle FAQ',
        name: 'FAQ Page',
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>

        <LayoutWrapperMain className={css.staticPageWrapper}>
              <h1 className={css.pageTitle}>Frequently Asked Questions.</h1>
              <h3 className={css.subtitle}>What are the fees?</h3>

              <p>
                WeCycle allows sellers and buyers to safely transact by charging 3% commission on sales and purchases. Our payment partnership with PayPal offers users reliable assistance, protection, and transparency on all transactions. Your satisfaction, guaranteed. All purchases made through a PayPal account are eligible.<br/><br/>
                Learn more here:  <ExternalLink href="https://www.paypal.com/us/webapps/mpp/paypal-safety-and-security">PayPal Safety & Security</ExternalLink>.<br/><br/>
                Please note: there is a standard payment processing fee (i.e. PayPal goods + services fee) for all transactions.
              </p>

              <h3 className={css.subtitle}>
                Is there a limit to the amount of items I can list or a fee for listing?
              </h3>
              <p>
                You can add, edit, or delete listings at any time. We don't charge a listing fee or a subscription fee.
              </p>
          <h3 className={css.subtitle}>
            When do I ship an item that is sold?
          </h3>
          <p>
            It is best practice to ship an item within 5 days after it was sold. After 5 days, the Buyer is eligible for a full refund at their request. If you aren’t able to ship the item within 5 days, it’s a good idea to contact the buyer and/or WeCycle. Please ensure you ship the item with a tracking label so that there is a record of your shipment in case of any issues.
          </p>
          <h3 className={css.subtitle}>
            How do I determine shipping rates?
          </h3>
          <p>
            Sellers must include an appropriate shipping rate in their description. If you need help determining shipping rates, please contact us at <ExternalLink href="mailto:info@wecycleshop.com">info@wecycleshop.com</ExternalLink>.
          </p>
          <h3 className={css.subtitle}>
            When are the funds released?
          </h3>
          <p>
            As long as you provide valid tracking, your funds will be released to you from WeCycle to your account once the item has been delivered. Please note it may take up to 7 days for the funds to be directly deposited into your bank account via Stripe.
          </p>
          <h3 className={css.subtitle}>
            Is there a local pickup option?
          </h3>
          <p>
            Yes! We encourage users to facilitate a local pick-up option to save time and money, while benefiting the environment.<br/><br/>
            Sellers must include a local pickup option in their item listing. A buyer makes a purchase and selects local pickup during the checkout process. The buyer and seller are responsible to ensure logistics work and payment must be processed through WeCycle to be eligible for Buyer/Seller Protection.
          </p>
          <h3 className={css.subtitle}>
            What is WeCycle Buyer Protection?
          </h3>
          <p>
            When you purchase gear through WeCycle, we secure your funds until the your new item is confirmed as delivered. In the unlikely event that there is an issue, please contact us at <ExternalLink href="mailto:info@wecycleshop.com">info@wecycleshop.com</ExternalLink> so we can conduct an investigation and provide any necessary assistance to ensure the claim is settled in your favour.
          </p>
          <h3 className={css.subtitle}>
            What is WeCycle Seller Protection?
          </h3>
          <p>
            Sellers may be protected in the event of undelivered, lost, or stolen shipments if they adhere to the requirements of selling on WeCycle. In the unlikely event that there is an issue, please contact us at <ExternalLink href="mailto:info@wecycleshop.com">info@wecycleshop.com</ExternalLink> so we can conduct an investigation and provide any necessary assistance to ensure the claim is settled in your favour.
          </p>
          <h3 className={css.subtitle}>
            Is there a screening process?
          </h3>
          <p>
            All listings are carefully reviewed for authenticity and integrity and on a continued basis.
          </p>
          <div name="contact" id="contact">
            <h1>Contact Us</h1>
            <p>Still have questions? E-mail us at:<ExternalLink href="mailto:info@wecycleshop.com">info@wecycleshop.com</ExternalLink>.</p>
          </div>
        </LayoutWrapperMain>

        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </StaticPage>

  );
};

export default FAQPage;

